import httpClient from 'lib/httpClient';
import { createQueryString } from 'lib/utils';
import {
  PerkResponse,
  PerkRewardResponse,
  PerkRewardsQueryParams,
  PerksHomePageQueryParams,
  PerksQueryParams,
  PerksResponse,
  UnlockablePerksResponse,
  UnlockedPerksResponse,
} from './types';

export const getPerksUrl = (params?: PerksQueryParams): string => {
  const formattedQueryString = createQueryString({
    page: params?.page,
    per_page: params?.perPage,
    sort_field: params?.sortField,
    sort_dir: params?.sortDir,
    rank_sort_dir: params?.rankSortDir,
    name: params?.name,
    title: params?.title,
    type: params?.type,
    status: params?.status,
    state: params?.state,
  });

  return `/perks?${formattedQueryString}`;
};

export const getUserPerksUrl = (
  userId: string,
  params?: Omit<PerksQueryParams, 'status'>,
): string => {
  const formattedQueryString = createQueryString({
    page: params?.page,
    per_page: params?.perPage,
    sort_field: params?.sortField,
    sort_dir: params?.sortDir,
    name: params?.name,
    title: params?.title,
    type: params?.type,
  });

  return `/users/${userId}/perks?${formattedQueryString}`;
};

export const getUserPerkRewardsUrl = (
  userId: string,
  params?: PerkRewardsQueryParams,
): string => {
  const formattedQueryString = createQueryString({
    page: params?.page,
    per_page: params?.perPage,
  });

  return `/users/${userId}/unlocked_rewards?${formattedQueryString}`;
};

export const getPerks = async (
  params?: PerksQueryParams,
): Promise<PerksResponse> => {
  const response = await httpClient.get<PerksResponse>(
    getPerksUrl(params),
  );

  return response.data;
};

export const getUserPerks = async (
  userId: string,
  params?: Omit<PerksQueryParams, 'status'>,
) => {
  const response = await httpClient.get<PerksResponse>(
    getUserPerksUrl(userId, params),
  );

  return response.data;
};

export const getUserPerkRewards = async (
  userId: string,
  params?: PerkRewardsQueryParams,
) => {
  const response = await httpClient.get<UnlockedPerksResponse>(
    getUserPerkRewardsUrl(userId, params),
  );

  return response.data;
};

export const getUnlockablePerks = async (userId: string) => {
  const response = await httpClient.get<UnlockablePerksResponse>(
    `/users/${userId}/unlockable_perks`,
  );

  return response.data;
};

export const unlockPerk = async (
  perkId: number,
): Promise<PerkResponse> => {
  const response = await httpClient.put<PerkResponse>(
    `/perks/${perkId}/unlock`,
  );

  return response.data;
};

export const redeemPerkReward = async (
  perkRewardId: number,
  code: string,
): Promise<PerkRewardResponse> => {
  const response = await httpClient.put(
    `/perk_rewards/${perkRewardId}/redeem`,
    { code },
  );

  return response.data;
};

export const getPerksHomepageUrl = (
  userId: string,
  params?: PerksHomePageQueryParams,
): string => {
  const formattedQueryString = createQueryString({
    page: params?.page,
    per_page: params?.perPage,
  });

  return `/users/${userId}/homepage_perks?${formattedQueryString}`;
};

export const getPerksHomepage = async (
  userId: string,
  params?: PerksHomePageQueryParams,
): Promise<PerksResponse> => {
  const response = await httpClient.get<PerksResponse>(
    getPerksHomepageUrl(userId, params),
  );

  return response.data;
};
